<template>
    <div>
      <h1 class="text-success">Formulario del nombre de la vacuna para Mujer Embarazada</h1>
      <div class="alert alert-info" role="alert">
      <strong>Nota:</strong> Este formulario agregará el nombre de la vacuna en el Esquema de vacunación para
embarazadas.
    </div>
      <div class="mt-4">
        <button @click="showCreateForm" class="btn btn-primary">Agregar Nombre Vacuna</button>
      </div>
  
      <!-- Lista de VacunaNombreMujer en una tabla -->
      <div class="table-responsive mt-3">
        <table class="table table-bordered">
          <thead class="thead-light">
            <tr>
              <th>Nombre de la vacuna</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="vacunaNombreMujer in vacunaNombreMujerList" :key="vacunaNombreMujer._id">
              <td>{{ vacunaNombreMujer.nombre }}</td>
              <td>
                <div class="btn-group" role="group">
                  <button @click="editVacunaNombreMujer(vacunaNombreMujer)" class="btn btn-warning btn-sm">Editar</button>
                  <button @click="deleteVacunaNombreMujer(vacunaNombreMujer._id)" class="btn btn-danger btn-sm">Eliminar</button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
  
      <!-- Formulario de creación/editar -->
      <div v-if="showForm" class="mt-4">
        <h2 class="h4">{{ isEditing ? 'Editar VacunaNombreMujer' : 'Agregar VacunaNombreMujer' }}</h2>
        <form @submit.prevent="isEditing ? updateVacunaNombreMujer() : createVacunaNombreMujer()" class="form-inline">
          <div class="form-group mr-2">
            <label for="nombre" class="mr-2">Nombre</label>
            <input v-model="formData.nombre" type="text" id="nombre" required class="form-control form-control-lg" />
          </div>
          <div class="btn-group">
            <button type="submit" class="btn btn-primary">{{ isEditing ? 'Guardar Cambios' : 'Agregar' }}</button>
            <button @click="cancelEdit" class="btn btn-secondary">Cancelar</button>
          </div>
        </form>
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  import swal from 'sweetalert';
  import { BASE_URL } from '../store/config';
  
  export default {
    computed: {
      currentUser() {
        return this.$store.state.auth.user;
      },
    },
    data() {
      return {
        vacunaNombreMujerList: [],
        showForm: false,
        formData: {
          nombre: '',
        },
        isEditing: false,
        editingVacunaNombreMujerId: null,
      };
    },
    methods: {
      async fetchVacunaNombreMujer() {
        try {
          const response = await axios.get(`${BASE_URL}/api/vacunanombremujer`, {
            headers: {
              'x-access-token': this.$store.state.auth.user.accessToken,
            },
          });
          this.vacunaNombreMujerList = response.data;
        } catch (error) {
          console.error('Error al obtener VacunaNombreMujer:', error);
        }
      },
      showCreateForm() {
        this.showForm = true;
        this.isEditing = false;
        this.formData = {
          nombre: '',
        };
      },
      async createVacunaNombreMujer() {
        try {
          await axios.post(`${BASE_URL}/api/vacunanombremujer`, this.formData, {
            headers: {
              'x-access-token': this.$store.state.auth.user.accessToken,
            },
          });
          swal({
            title: '¡Información Guardada!',
            text: 'La información de VacunaNombreMujer ha sido guardada correctamente.',
            icon: 'success',
            button: 'OK',
          });
          this.clearFields();
          this.fetchVacunaNombreMujer();
          this.showForm = false;
        } catch (error) {
          swal({
            title: 'Error',
            text: `Hubo un error al guardar la información de VacunaNombreMujer. \n ${error.response.data.message}.`,
            icon: 'error',
            button: 'OK',
          });
        }
      },
      clearFields() {
        this.formData = {
          nombre: '',
        };
      },
      deleteVacunaNombreMujer(id) {
        swal({
          title: '¿Estás seguro?',
          text: 'Una vez eliminado, no podrás recuperar este registro.',
          icon: 'warning',
          buttons: ['Cancelar', 'Eliminar'],
          dangerMode: true,
        })
        .then((confirmation) => {
          if (confirmation) {
            this.performVacunaNombreMujerDeletion(id);
          }
        });
      },
      async performVacunaNombreMujerDeletion(id) {
        try {
          await axios.delete(`${BASE_URL}/api/vacunanombremujer/${id}`, {
            headers: {
              'x-access-token': this.$store.state.auth.user.accessToken,
            },
          });
          swal({
            title: '¡Información Eliminada!',
            text: 'La información de VacunaNombreMujer ha sido eliminada correctamente.',
            icon: 'success',
            button: 'OK',
          });
          this.fetchVacunaNombreMujer();
        } catch (error) {
          swal({
            title: 'Error',
            text: 'Hubo un error al eliminar la información de VacunaNombreMujer.',
            icon: 'error',
            button: 'OK',
          });
        }
      },
      editVacunaNombreMujer(vacunaNombreMujer) {
        this.isEditing = true;
        this.editingVacunaNombreMujerId = vacunaNombreMujer._id;
        this.formData.nombre = vacunaNombreMujer.nombre;
        this.showForm = true;
      },
      async updateVacunaNombreMujer() {
        try {
          await axios.put(`${BASE_URL}/api/vacunanombremujer/${this.editingVacunaNombreMujerId}`, this.formData, {
            headers: {
              'x-access-token': this.$store.state.auth.user.accessToken,
            },
          });
          swal({
            title: '¡Información Actualizada!',
            text: 'La información de VacunaNombreMujer ha sido actualizada correctamente.',
            icon: 'success',
            button: 'OK',
          });
          this.clearFields();
          this.fetchVacunaNombreMujer();
          this.showForm = false;
        } catch (error) {
          swal({
            title: 'Error',
            text: `Hubo un error al editar la información de VacunaNombreMujer. \n ${error.response.data.message}.`,
            icon: 'error',
            button: 'OK',
          });
        }
      },
      cancelEdit() {
        this.showForm = false;
        this.isEditing = false;
        this.clearFields();
      },
    },
    mounted() {
      this.fetchVacunaNombreMujer();
    },
  };
  </script>
  
  <style scoped>
  /* Estilos adicionales si es necesario */
  </style>
  